
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1bRYB", function(module, exports) {
/**
 * marked v18.1.1 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    module.exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : module.exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var V = Object.defineProperty;
    var Me = Object.getOwnPropertyDescriptor;
    var Ce = Object.getOwnPropertyNames;
    var Ie = Object.prototype.hasOwnProperty;
    var Be = (a, e)=>{
        for(var t in e)V(a, t, {
            get: e[t],
            enumerable: !0
        });
    }, De = (a, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let i of Ce(e))!Ie.call(a, i) && i !== t && V(a, i, {
            get: ()=>e[i],
            enumerable: !(n = Me(e, i)) || n.enumerable
        });
        return a;
    };
    var qe = (a)=>De(V({}, "__esModule", {
            value: !0
        }), a);
    var jt = {};
    Be(jt, {
        Hooks: ()=>$,
        Lexer: ()=>T,
        Marked: ()=>H,
        Parser: ()=>O,
        Renderer: ()=>_,
        TextRenderer: ()=>A,
        Tokenizer: ()=>S,
        defaults: ()=>w,
        getDefaults: ()=>M,
        lexer: ()=>Qt,
        marked: ()=>g,
        options: ()=>qt,
        parse: ()=>Gt,
        parseInline: ()=>Ht,
        parser: ()=>Nt,
        setOptions: ()=>Zt,
        use: ()=>Le,
        walkTokens: ()=>vt
    });
    module1.exports = qe(jt);
    function M() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var w = M();
    function J(a) {
        w = a;
    }
    var C = {
        exec: ()=>null
    };
    function D(a) {
        let e = [];
        return (t)=>{
            let n = Math.max(0, Math.min(3, t - 1)), i = e[n];
            return i || (i = a(n), e[n] = i), i;
        };
    }
    function h(a, e = "") {
        let t = typeof a == "string" ? a : a.source, n = {
            replace: (i, r)=>{
                let o = typeof r == "string" ? r : r.source;
                return o = o.replace(x.caret, "$1"), t = t.replace(i, o), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var Ze = ((a = "")=>{
        try {
            return new RegExp("(?<=1)(?<!1)" + a), true;
        } catch  {
            return !1;
        }
    })(), x = {
        codeRemoveIndent: /^(?: {0,3}\t| {1,4})/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        endingSpaceTabChar: /[ \t]$/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        leadingSpaceTab: /^[ \t]+/,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] +\S/,
        listReplaceTask: /^\[[ xX]\] +/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        numericCharacterReference: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));/,
        numericCharacterReferenceOrAmpersand: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (a)=>new RegExp(`^( {0,3}${a})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: D((a)=>new RegExp(`^ {0,${a}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
        hrRegex: D((a)=>new RegExp(`^ {0,${a}}((?:-[ 	]*){3,}|(?:_[ 	]*){3,}|(?:\\*[ 	]*){3,})(?:\\n+|$)`)),
        fencesBeginRegex: D((a)=>new RegExp(`^ {0,${a}}(?:\`\`\`|~~~)`)),
        headingBeginRegex: D((a)=>new RegExp(`^ {0,${a}}#`)),
        htmlBeginRegex: D((a)=>new RegExp(`^ {0,${a}}(?:</?(?:${j})(?: +|$|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)`, "i")),
        blockquoteBeginRegex: D((a)=>new RegExp(`^ {0,${a}}>`))
    }, ve = /^(?:[ \t]*(?:\n|$))+/, He = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Ge = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, Q = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Ne = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, ee = / {0,3}(?:[*+-]|\d{1,9}[.)])/, me = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |fences|blockquote|heading|hr|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, xe = h(me).replace(/bull/g, ee).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Qe = h(me).replace(/bull/g, ee).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), te = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table|[ \t]+\n)[^\n]+)*)/, je = /^[^\n]+/, ne = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, Fe = h(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", ne).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Ue = h(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, ee).getRegex(), j = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", re = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Ke = h("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n*|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>[^\\n]*\\n*|$)|<![A-Z][\\s\\S]*?(?:>[^\\n]*\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>[^\\n]*\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!(?:script|pre|style|textarea)(?![a-z0-9-]))([a-z][a-z0-9-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</[a-z][a-z0-9-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", re).replace("tag", j).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), be = (a)=>h(te).replace("hr", Q).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", a).replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", j).getRegex(), Xe = be(/ {0,3}(?:[*+-]|1[.)])[ \t]+[^ \t\n]/), We = be(/ {0,3}(?:[*+-]|\d{1,9}[.)])(?:[ \t]|\n|$)/), Ve = h(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", We).getRegex(), se = {
        blockquote: Ve,
        code: He,
        def: Fe,
        fences: Ge,
        heading: Ne,
        hr: Q,
        html: Ke,
        lheading: xe,
        list: Ue,
        newline: ve,
        paragraph: Xe,
        table: C,
        text: je
    }, ke = h("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", Q).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", j).getRegex(), Je = {
        ...se,
        lheading: Qe,
        table: ke,
        paragraph: h(te).replace("hr", Q).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", ke).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", j).getRegex()
    }, Ye = {
        ...se,
        html: h(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", re).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: C,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: h(te).replace("hr", Q).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", xe).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }, et = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, tt = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, Re = /^( {2,}|\\)\n(?!\s*$)[ \t]*/, nt = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, L = /[\p{P}\p{S}]/u, q = /[\s\p{P}\p{S}]/u, F = /[^\s\p{P}\p{S}]/u, rt = h(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, q).getRegex(), st = /[\p{Pi}\p{Ps}"']/u, Te = /(?!~)[\p{P}\p{S}]/u, it = /(?!~)[\s\p{P}\p{S}]/u, ot = /(?:[^\s\p{P}\p{S}]|~)/u, at = h(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", Ze ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), Oe = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, lt = h(Oe, "u").replace(/punct/g, L).getRegex(), ut = h(Oe, "u").replace(/punct/g, Te).getRegex(), pt = /^(?:\*+(?:((?!\*)(?!openQuote)punct)|([^\s*]))?)|^_+(?:((?!_)(?!openQuote)punct)|([^\s_]))?/, ct = h(pt, "u").replace(/openQuote/g, st).replace(/punct/g, L).getRegex(), we = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", ht = h(we, "gu").replace(/notPunctSpace/g, F).replace(/punctSpace/g, q).replace(/punct/g, L).getRegex(), dt = h(we, "gu").replace(/notPunctSpace/g, ot).replace(/punctSpace/g, it).replace(/punct/g, Te).getRegex(), kt = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)[\\s](\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|(?:(?!\\*)punct|notPunctSpace)(\\*+)(?!\\*)(?=notPunctSpace)", gt = h(kt, "gu").replace(/notPunctSpace/g, F).replace(/punctSpace/g, q).replace(/punct/g, L).getRegex(), ft = h("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, F).replace(/punctSpace/g, q).replace(/punct/g, L).getRegex(), mt = "^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)[\\s](_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)|(?:(?!_)punct|notPunctSpace)(_+)(?!_)(?=notPunctSpace)", xt = h(mt, "gu").replace(/notPunctSpace/g, F).replace(/punctSpace/g, q).replace(/punct/g, L).getRegex(), bt = h(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, L).getRegex(), Rt = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", Tt = h(Rt, "gu").replace(/notPunctSpace/g, F).replace(/punctSpace/g, q).replace(/punct/g, L).getRegex(), Ot = h(/\\(punct)/, "gu").replace(/punct/g, L).getRegex(), wt = h(/(`+)(?:[^`]|[^`][\s\S]*?[^`])\1(?!`)|`+|\\(punct)/, "gu").replace(/punct/g, L).getRegex(), Pt = h(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), yt = h(re).replace("(?:-->|$)", "-->").getRegex(), St = h("^comment|^</[a-zA-Z][a-zA-Z0-9-]*\\s*>|^<[a-zA-Z][a-zA-Z0-9-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", yt).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), Pe = /\[(?:\\[\s\S]|[^\[\]\\])*\]/, K = h(/(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/).replace("brackets", Pe).getRegex(), _t = h(/^!?\[(label)\]\([ \t\n]*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?[ \t\n]*\)/).replace("label", K).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]+|(?=\))/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), $t = h(/^!?\[(label)\]\[(ref)\]/).replace("label", K).replace("ref", ne).getRegex(), Lt = h(/^!?\[(ref)\](?:\[\])?/).replace("ref", ne).getRegex(), ge = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\]){1,999}/, At = h(/(?:[^\[\]\\`]*(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\]))){0,999}?[^\[\]\\`]*?/).replace("brackets", Pe).getRegex(), zt = h("reflink|nolink(?!\\()", "g").replace("reflink", h(/^!?\[(label)\]\[(ref)\]/).replace("label", At).replace("ref", ge).getRegex()).replace("nolink", h(/^!?\[(ref)\](?:\[\])?/).replace("ref", ge).getRegex()).getRegex(), fe = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, Et = /[A-Za-z0-9._+-]+@[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/, Mt = h(/(?:mailto:email|xmpp:email(?:\/[A-Za-z0-9@.]+)?)/).replace(/email/g, Et).getRegex(), ie = {
        _backpedal: C,
        anyPunctuation: Ot,
        anyPunctuationOutsideCode: wt,
        autolink: Pt,
        blockSkip: at,
        br: Re,
        code: tt,
        del: C,
        delLDelim: C,
        delRDelim: C,
        emStrongLDelim: lt,
        emStrongRDelimAst: ht,
        emStrongRDelimUnd: ft,
        escape: et,
        link: _t,
        nolink: Lt,
        punctuation: rt,
        reflink: $t,
        reflinkSearch: zt,
        tag: St,
        text: nt,
        url: C
    }, Ct = {
        ...ie,
        emStrongLDelim: ct,
        emStrongRDelimAst: gt,
        emStrongRDelimUnd: xt,
        link: h(/^!?\[(label)\]\((.*?)\)/).replace("label", K).getRegex(),
        reflink: h(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", K).getRegex()
    }, Y = {
        ...ie,
        emStrongRDelimAst: dt,
        emStrongLDelim: ut,
        delLDelim: bt,
        delRDelim: Tt,
        url: h(/^emailProtocol|^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("emailProtocol", Mt).replace("protocol", fe).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: h(/^(?:[^a-zA-Z0-9](?=emailProtocol)|(`+|~+|[^`~])(?:(?=[`~])|(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9](?=emailProtocol)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))))/).replace("protocol", fe).replace(/emailProtocol/g, /(?:mailto|xmpp):/).getRegex()
    }, It = {
        ...Y,
        br: h(Re).replace("{2,}", "*").getRegex(),
        text: h(Y.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }, U = {
        normal: se,
        gfm: Je,
        pedantic: Ye
    }, Z = {
        normal: ie,
        gfm: Y,
        breaks: It,
        pedantic: Ct
    };
    var Bt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, ye = (a)=>Bt[a];
    function P(a, e) {
        if (e) {
            if (x.escapeTest.test(a)) return a.replace(x.escapeReplace, ye);
        } else if (x.escapeTestNoEncode.test(a)) return a.replace(x.escapeReplaceNoEncode, ye);
        return a;
    }
    function Se(a) {
        return x.numericCharacterReference.test(a) ? a.replace(x.numericCharacterReferenceOrAmpersand, (e, t, n)=>{
            if (t === void 0 && n === void 0) return "&amp;";
            let i = t === void 0 ? Number.parseInt(n, 16) : Number.parseInt(t, 10);
            return i === 0 || i > 1114111 || i >= 55296 && i <= 57343 ? "\uFFFD" : i === 38 ? "&amp;" : String.fromCodePoint(i);
        }) : a;
    }
    function oe(a) {
        try {
            a = encodeURI(a).replace(x.percentDecode, "%");
        } catch  {
            return null;
        }
        return a;
    }
    function ae(a, e) {
        let t = a.replace(x.findPipe, (r, o, s)=>{
            let l = !1, u = o;
            for(; --u >= 0 && s[u] === "\\";)l = !l;
            return l ? "|" : " |";
        }), n = t.split(x.splitPipe), i = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; i < n.length; i++)n[i] = n[i].trim().replace(x.slashPipe, "|");
        return n;
    }
    function z(a, e, t) {
        let n = a.length;
        if (n === 0) return "";
        let i = 0;
        for(; i < n;){
            let r = a.charAt(n - i - 1);
            if (r === e && !t) i++;
            else if (r !== e && t) i++;
            else break;
        }
        return a.slice(0, n - i);
    }
    function le(a) {
        let e = a.split(`
`), t = e.length - 1;
        for(; t >= 0 && x.blankLine.test(e[t]);)t--;
        return e.length - t <= 2 ? a : e.slice(0, t + 1).join(`
`);
    }
    function v(a) {
        return a.trim().toLowerCase().toUpperCase().toLowerCase();
    }
    function ue(a, e) {
        if (a.indexOf(e[0]) === -1 && a.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < a.length; n++)if (a[n] === "\\") n++;
        else if (a[n] === e[0]) t++;
        else if (a[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    function X(a, e = 0) {
        let t = e, n = "";
        for (let i of a)if (i === "	") {
            let r = 4 - t % 4;
            n += " ".repeat(r), t += r;
        } else n += i, t++;
        return n;
    }
    function _e(a, e, t, n, i) {
        let r = e.href, o = e.title || null, s = a[1].replace(i.other.outputLinkReplace, "$1"), l = a[0].charAt(0) === "!", u = n.state.inLink, c = n.state.linkEmitted, p = n.state.inRawBlock;
        n.state.inLink = !0, n.state.linkEmitted = !1;
        let d = n.inlineTokens(s), f = n.state.linkEmitted;
        if (n.state.linkEmitted = c, n.state.inLink = u, !l) {
            if (f) {
                n.state.inRawBlock = p;
                return;
            }
            n.state.linkEmitted = !0;
        }
        return {
            type: l ? "image" : "link",
            raw: t,
            href: r,
            title: o,
            text: s,
            tokens: d
        };
    }
    function Dt(a, e, t) {
        let n = a.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let i = n[1];
        return e.split(`
`).map((r)=>{
            let o = r.match(t.other.beginningSpace);
            if (o === null) return r;
            let [s] = o;
            return r.slice(Math.min(s.length, i.length));
        }).join(`
`);
    }
    function $e(a, e, t, n) {
        if (!e.includes("<")) return !1;
        for(let i = 0; i < e.length; i++){
            if (e[i] === "\\") {
                i++;
                continue;
            }
            if (e[i] === "`") {
                let s = n.inline.code.exec(e.slice(i));
                if (s) {
                    i += s[0].length - 1;
                    continue;
                }
            }
            if (e[i] !== "<") continue;
            let r = a.slice(t + i), o = n.inline.tag.exec(r) || n.inline.autolink.exec(r);
            if (o) {
                if (o[0].length > e.length - i) return !0;
                i += o[0].length - 1;
            }
        }
        return !1;
    }
    var S = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || w;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = this.options.pedantic ? t[0] : le(t[0]), i = n.replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: n,
                    codeBlockStyle: "indented",
                    text: i
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], i = Dt(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: i
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let i = z(n, "#");
                    (this.options.pedantic || !i || this.rules.other.endingSpaceTabChar.test(i)) && (n = i.trim());
                }
                return {
                    type: "heading",
                    raw: z(t[0], `
`),
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: z(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = z(t[0], `
`).split(`
`), i = "", r = "", o = [];
                for(; n.length > 0;){
                    let s = !1, l = [], u;
                    for(u = 0; u < n.length; u++)if (this.rules.other.blockquoteStart.test(n[u])) l.push(n[u]), s = !0;
                    else if (!s) l.push(n[u]);
                    else break;
                    n = n.slice(u);
                    let c = l.join(`
`), p = c.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    i = i ? `${i}
${c}` : c, r = r ? `${r}
${p}` : p;
                    let d = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(p, o, !0), this.lexer.state.top = d, n.length === 0) break;
                    let f = o.at(-1);
                    if (f?.type === "code" || f?.type === "heading" || f?.type === "hr" || f?.type === "html") break;
                    if (f?.type === "blockquote") {
                        let k = f, y = n.join(`
`), R = k.raw + `
` + y.replace(this.rules.other.blockquoteSetextReplace2, ""), m = this.blockquote(R);
                        o[o.length - 1] = m;
                        let E = R.substring(m.raw.length).replace(/^\n/, ""), b = E ? E.split(`
`).length : 0, G = b ? n.slice(0, -b) : n;
                        G.length > 0 && (i = `${i}
${G.join(`
`)}`), r = r.substring(0, r.length - k.text.length) + m.text;
                        break;
                    } else if (f?.type === "list") {
                        let k = f, y = k.raw + `
` + n.join(`
`), R = this.list(y);
                        o[o.length - 1] = R, i = i.substring(0, i.length - f.raw.length) + R.raw, r = r.substring(0, r.length - k.raw.length) + R.raw, n = y.substring(o.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: i,
                    tokens: o,
                    text: r
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = e, i = ()=>n.length - e.length, r = t[1].trim(), o = r.length > 1, s = {
                    type: "list",
                    raw: "",
                    ordered: o,
                    start: o ? +r.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                r = o ? `\\d{1,9}\\${r.slice(-1)}` : `\\${r}`, this.options.pedantic && (r = o ? r : "[*+-]");
                let l = this.rules.other.listItemRegex(r), u = !1;
                for(; e;){
                    let p = !1, d = "";
                    if (!(t = l.exec(e)) || this.rules.block.hr.test(e)) break;
                    let f = i();
                    e = e.substring(t[0].length);
                    let k = t[2].split(`
`, 1)[0], y = t[1].length, R = this.options.pedantic ? X(k, y) : k.replace(this.rules.other.leadingSpaceTab, (W)=>X(W, y)), m = e.split(`
`, 1)[0], E = !R.trim(), b = 0;
                    if (this.options.pedantic ? (b = 2, d = R.trimStart()) : E ? b = y + 1 : (b = R.search(this.rules.other.nonSpaceChar), b = b > 4 ? 1 : b, d = R.slice(b), b += y), E && this.rules.other.blankLine.test(m) && (e = e.substring(m.length + 1), p = !0), !p) {
                        let W = this.rules.other.nextBulletRegex(b), pe = this.rules.other.hrRegex(b), ce = this.rules.other.fencesBeginRegex(b), he = this.rules.other.headingBeginRegex(b), Ae = this.rules.other.htmlBeginRegex(b), ze = this.rules.other.blockquoteBeginRegex(b);
                        for(; e;){
                            let de = e.split(`
`, 1)[0], N;
                            if (m = de, this.options.pedantic ? (m = m.replace(this.rules.other.listReplaceNesting, "  "), N = m) : N = m.replace(this.rules.other.leadingSpaceTab, (Ee)=>X(Ee)), ce.test(m) || he.test(m) || Ae.test(m) || ze.test(m) || W.test(m) || pe.test(m)) break;
                            if (N.search(this.rules.other.nonSpaceChar) >= b || !m.trim()) d += `
` + N.slice(b);
                            else {
                                if (E || R.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || ce.test(R) || he.test(R) || pe.test(R)) break;
                                d += `
` + m;
                            }
                            E = !m.trim(), e = e.substring(de.length + 1), R = N.slice(b);
                        }
                    }
                    let G = n.slice(f, i());
                    s.loose || (u ? s.loose = !0 : this.rules.other.doubleBlankLine.test(G) && (u = !0)), s.items.push({
                        type: "list_item",
                        raw: G,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(d),
                        loose: !1,
                        text: d,
                        tokens: []
                    });
                }
                let c = s.items.at(-1);
                if (c) c.raw = c.raw.trimEnd(), c.text = c.text.trimEnd();
                else return;
                s.raw = n.slice(0, i()).trimEnd();
                for (let p of s.items)if (this.lexer.state.top = !1, p.tokens = this.lexer.blockTokens(p.text, []), !s.loose) {
                    let d = p.tokens.filter((k)=>k.type === "space"), f = d.length > 0 && d.some((k)=>this.rules.other.anyLine.test(k.raw));
                    s.loose = f;
                }
                for (let p of s.items){
                    let d = p.tokens[0];
                    if (p.task && (d?.type === "text" || d?.type === "paragraph")) {
                        p.text = p.text.replace(this.rules.other.listReplaceTask, ""), d.raw = d.raw.replace(this.rules.other.listReplaceTask, ""), d.text = d.text.replace(this.rules.other.listReplaceTask, "");
                        for(let k = this.lexer.inlineQueue.length - 1; k >= 0; k--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[k].src)) {
                            this.lexer.inlineQueue[k].src = this.lexer.inlineQueue[k].src.replace(this.rules.other.listReplaceTask, "");
                            break;
                        }
                        let f = this.rules.other.listTaskCheckbox.exec(p.raw);
                        if (f) {
                            let k = {
                                type: "checkbox",
                                raw: f[0] + " ",
                                checked: f[0] !== "[ ]"
                            };
                            p.checked = k.checked, s.loose ? p.tokens[0] && [
                                "paragraph",
                                "text"
                            ].includes(p.tokens[0].type) && "tokens" in p.tokens[0] && p.tokens[0].tokens ? (p.tokens[0].raw = k.raw + p.tokens[0].raw, p.tokens[0].text = k.raw + p.tokens[0].text, p.tokens[0].tokens.unshift(k)) : p.tokens.unshift({
                                type: "paragraph",
                                raw: k.raw,
                                text: k.raw,
                                tokens: [
                                    k
                                ]
                            }) : p.tokens.unshift(k);
                        }
                    } else p.task && (p.task = !1);
                }
                if (s.loose) for (let p of s.items){
                    p.loose = !0;
                    for (let d of p.tokens)d.type === "text" && (d.type = "paragraph");
                }
                return s;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) {
                let n = le(t[0]);
                return {
                    type: "html",
                    block: !0,
                    raw: n,
                    pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                    text: n
                };
            }
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                if (!this.rules.other.startAngleBracket.test(t[2]) && ue(t[2], "()") !== -1) return;
                let n = v(t[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: z(t[0], `
`),
                    href: i,
                    title: r
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = ae(t[1]), i = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), r = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], o = {
                type: "table",
                raw: z(t[0], `
`),
                header: [],
                align: [],
                rows: []
            };
            if (n.length === i.length) {
                for (let s of i)this.rules.other.tableAlignRight.test(s) ? o.align.push("right") : this.rules.other.tableAlignCenter.test(s) ? o.align.push("center") : this.rules.other.tableAlignLeft.test(s) ? o.align.push("left") : o.align.push(null);
                for(let s = 0; s < n.length; s++)o.header.push({
                    text: n[s],
                    tokens: this.lexer.inline(n[s]),
                    header: !0,
                    align: o.align[s]
                });
                for (let s of r)o.rows.push(ae(s, o.header.length).map((l, u)=>({
                        text: l,
                        tokens: this.lexer.inline(l),
                        header: !1,
                        align: o.align[u]
                    })));
                return o;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let n = t[1].trim();
                return {
                    type: "heading",
                    raw: z(t[0], `
`),
                    depth: t[2].charAt(0) === "=" ? 1 : 2,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            if (this.lexer.state.linkParenPossible === !1) return;
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[0].charAt(0) === "!" ? 2 : 1;
                if (!this.options.pedantic && $e(e, t[1], n, this.rules)) return;
                let i = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(i)) {
                    if (!this.rules.other.endAngleBracket.test(i)) return;
                    let s = z(i.slice(0, -1), "\\");
                    if ((i.length - s.length) % 2 === 0) return;
                } else {
                    let s = ue(t[2], "()");
                    if (s === -2) return;
                    if (s > -1) {
                        let u = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + s;
                        t[2] = t[2].substring(0, s), t[0] = t[0].substring(0, u).trim(), t[3] = "";
                    }
                }
                let r = t[2], o = "";
                if (this.options.pedantic) {
                    let s = this.rules.other.pedanticHrefTitle.exec(r);
                    s && (r = s[1], o = s[3]);
                } else o = t[3] ? t[3].slice(1, -1) : "";
                return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(i) ? r = r.slice(1) : r = r.slice(1, -1)), _e(t, {
                    href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: o && o.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let i = n[0].charAt(0) === "!" ? 2 : 1;
                if (!this.options.pedantic && $e(e, n[1], i, this.rules)) return;
                let r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), o = t[v(r)];
                if (!o) {
                    let s = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: s,
                        text: s
                    };
                }
                return _e(n, o, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let i = this.rules.inline.emStrongLDelim.exec(e);
            if (!i || !i[1] && !i[2] && !i[3] && !i[4] || i[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            if (!(i[1] || i[3] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let o = [
                    ...i[0]
                ].length - 1, s, l, u = o, c = 0, p = i[0][0], d = n === p, f = p === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(f.lastIndex = 0, t = t.slice(-1 * e.length + o); (i = f.exec(t)) !== null;){
                    if (s = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !s) continue;
                    if (l = [
                        ...s
                    ].length, i[3] || i[4]) {
                        u += l;
                        continue;
                    } else if (i[5] || i[6]) {
                        if (o % 3 && !((o + l) % 3)) {
                            c += l;
                            continue;
                        }
                        if (d) break;
                    }
                    if (u -= l, u > 0) continue;
                    l = Math.min(l, l + u + c);
                    let k = [
                        ...i[0]
                    ][0].length, y = e.slice(0, o + i.index + k + l);
                    if (Math.min(o, l) % 2) {
                        let m = y.slice(1, -1);
                        return {
                            type: "em",
                            raw: y,
                            text: m,
                            tokens: this.lexer.inlineTokens(m)
                        };
                    }
                    let R = y.slice(2, -2);
                    return {
                        type: "strong",
                        raw: y,
                        text: R,
                        tokens: this.lexer.inlineTokens(R)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), i = this.rules.other.nonSpaceChar.test(n), r = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return i && r && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e, t, n = "") {
            let i = this.rules.inline.delLDelim.exec(e);
            if (!i) return;
            if (!(i[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let o = [
                    ...i[0]
                ].length - 1, s, l, u = o, c = this.rules.inline.delRDelim;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + o); (i = c.exec(t)) !== null;){
                    if (s = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !s || (l = [
                        ...s
                    ].length, l !== o)) continue;
                    if (i[3] || i[4]) {
                        u += l;
                        continue;
                    }
                    if (u -= l, u > 0) continue;
                    l = Math.min(l, l + u);
                    let p = [
                        ...i[0]
                    ][0].length, d = e.slice(0, o + i.index + p + l), f = d.slice(o, -o);
                    return {
                        type: "del",
                        raw: d,
                        text: f,
                        tokens: this.lexer.inlineTokens(f)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, i;
                return t[2] === "@" ? (n = t[1], i = "mailto:" + n) : (n = t[1], i = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: i,
                    autolink: !0,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, i;
                if (t[2] === "@") n = t[0], i = "mailto:" + n;
                else {
                    let r;
                    do r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                    while (r !== t[0]);
                    n = t[0], t[1] === "www." ? i = "http://" + t[0] : i = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: i,
                    autolink: !0,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: n ? t[0] : Se(t[0]),
                    escaped: n
                };
            }
        }
    };
    var T = class a {
        tokens;
        options;
        state;
        inlineQueue;
        tokenizer;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || w, this.options.tokenizer = this.options.tokenizer || new S, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                linkEmitted: !1,
                linkParenPossible: !0,
                top: !0
            };
            let t = {
                other: x,
                block: U.normal,
                inline: Z.normal
            };
            this.options.pedantic ? (t.block = U.pedantic, t.inline = Z.pedantic) : this.options.gfm && (t.block = U.gfm, this.options.breaks ? t.inline = Z.breaks : t.inline = Z.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: U,
                inline: Z
            };
        }
        static lex(e, t) {
            return new a(t).lex(e);
        }
        static lexInline(e, t) {
            return new a(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(x.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(x.tabCharGlobal, "    ").replace(x.spaceLine, ""));
            let i = 1 / 0;
            for(; e;){
                if (e.length < i) i = e.length;
                else {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
                let r;
                if (this.options.extensions?.block?.some((s)=>(r = s.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    r.raw.length === 1 && s !== void 0 ? s.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.raw, this.inlineQueue.at(-1).src = s.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let o = e;
                if (this.options.extensions?.startBlock) {
                    let s = 1 / 0, l = e.slice(1), u;
                    this.options.extensions.startBlock.forEach((c)=>{
                        u = c.call({
                            lexer: this
                        }, l), typeof u == "number" && u >= 0 && (s = Math.min(s, u));
                    }), s < 1 / 0 && s >= 0 && (o = e.substring(0, s + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(o))) {
                    let s = t.at(-1);
                    n && s?.type === "paragraph" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r), n = o.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (e) {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        linkInText(e) {
            if (!e.includes("[")) return !1;
            let t = this.tokenizer.rules.inline.link;
            for (let n of e.matchAll(this.tokenizer.rules.inline.blockSkip))if (t.test(n[0]) && e.charAt(n.index - 1) !== "!") return !0;
            for (let n of e.matchAll(this.tokenizer.rules.inline.reflinkSearch)){
                let i = n[0], r = i.lastIndexOf("[");
                if (!(i.charAt(0) === "!" || !Object.hasOwn(this.tokens.links, v(i.slice(r + 1, -1)))) && !(r > 1 && this.linkInText(i.slice(1, r - 1)))) return !0;
            }
            return !1;
        }
        inlineTokens(e, t = []) {
            this.tokenizer.lexer = this;
            let n = this.state.linkParenPossible;
            this.state.linkParenPossible = n && e.includes(")");
            try {
                return this.#e(e, t);
            } finally{
                this.state.linkParenPossible = n;
            }
        }
        #e(e, t) {
            let n = e;
            if (this.tokens.links && e.includes("[")) {
                let s = this.tokenizer.rules.inline.reflinkSearch, l = (u)=>{
                    let c = u.lastIndexOf("[");
                    if (!Object.hasOwn(this.tokens.links, v(u.slice(c + 1, -1)))) return u;
                    if (c > 1 && u.charAt(0) !== "!") {
                        let p = u.slice(1, c - 1);
                        if (this.linkInText(p)) return "[" + p.replace(s, l) + "][" + "a".repeat(u.length - c - 2) + "]";
                    }
                    return "[" + "a".repeat(u.length - 2) + "]";
                };
                n = n.replace(s, l);
            }
            n = n.replace(this.tokenizer.rules.inline.anyPunctuationOutsideCode, (s, l, u)=>u ? "+".repeat(s.length) : l ? l + s.slice(l.length, -l.length).replace(/`/g, "+") + l : s), n = n.replace(this.tokenizer.rules.inline.blockSkip, (s, l, u)=>{
                let c = u ? u.length : 0;
                return s.slice(0, c) + "[" + "a".repeat(s.length - c - 2) + "]";
            }), n = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, n) ?? n;
            let i = !1, r = "", o = 1 / 0;
            for(; e;){
                if (e.length < o) o = e.length;
                else {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
                i || (r = ""), i = !1;
                let s;
                if (this.options.extensions?.inline?.some((u)=>(s = u.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(s.raw.length), t.push(s), !0) : !1)) continue;
                if (s = this.tokenizer.escape(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.tag(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.link(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(s.raw.length);
                    let u = t.at(-1);
                    s.type === "text" && u?.type === "text" ? (u.raw += s.raw, u.text += s.text) : t.push(s);
                    continue;
                }
                if (s = this.tokenizer.emStrong(e, n, r)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.codespan(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.br(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.del(e, n, r)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.autolink(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (!this.state.inLink && (s = this.tokenizer.url(e))) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                let l = e;
                if (this.options.extensions?.startInline) {
                    let u = 1 / 0, c = e.slice(1), p;
                    this.options.extensions.startInline.forEach((d)=>{
                        p = d.call({
                            lexer: this
                        }, c), typeof p == "number" && p >= 0 && (u = Math.min(u, p));
                    }), u < 1 / 0 && u >= 0 && (l = e.substring(0, u + 1));
                }
                if (s = this.tokenizer.inlineText(l)) {
                    e = e.substring(s.raw.length), s.raw.slice(-1) !== "_" && (r = s.raw.slice(-1)), i = !0;
                    let u = t.at(-1);
                    u?.type === "text" ? (u.raw += s.raw, u.text += s.text) : t.push(s);
                    continue;
                }
                if (e) {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
            }
            return t;
        }
        infiniteLoopError(e) {
            let t = "Infinite loop on byte: " + e;
            if (this.options.silent) console.error(t);
            else throw new Error(t);
        }
    };
    var _ = class {
        options;
        parser;
        constructor(e){
            this.options = e || w;
        }
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            let i = (t || "").match(x.notSpaceStart)?.[0], r = e ? e.replace(x.endingNewline, "") + `
` : "";
            return i ? '<pre><code class="language-' + P(i) + '">' + (n ? r : P(r, !0)) + `</code></pre>
` : "<pre><code>" + (n ? r : P(r, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return "";
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, i = "";
            for(let s = 0; s < e.items.length; s++){
                let l = e.items[s];
                i += this.listitem(l);
            }
            let r = t ? "ol" : "ul", o = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + r + o + `>
` + i + "</" + r + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let r = 0; r < e.header.length; r++)n += this.tablecell(e.header[r]);
            t += this.tablerow({
                text: n
            });
            let i = "";
            for(let r = 0; r < e.rows.length; r++){
                let o = e.rows[r];
                n = "";
                for(let s = 0; s < o.length; s++)n += this.tablecell(o[s]);
                i += this.tablerow({
                    text: n
                });
            }
            return i && (i = `<tbody>${i}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + i + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${P(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, text: n, tokens: i, autolink: r }) {
            let o = r ? P(n, !0) : this.parser.parseInline(i), s = oe(e);
            if (s === null) return o;
            e = P(s, r);
            let l = '<a href="' + e + '"';
            return t && (l += ' title="' + P(t) + '"'), l += ">" + o + "</a>", l;
        }
        image({ href: e, title: t, text: n, tokens: i }) {
            i && (n = this.parser.parseInline(i, this.parser.textRenderer));
            let r = oe(e);
            if (r === null) return P(n);
            e = r;
            let o = `<img src="${P(e)}" alt="${P(n)}"`;
            return t && (o += ` title="${P(t)}"`), o += ">", o;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : P(e.text);
        }
    };
    var A = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return "" + e;
        }
        image({ text: e }) {
            return "" + e;
        }
        br() {
            return "";
        }
        checkbox({ raw: e }) {
            return e;
        }
    };
    var O = class a {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || w, this.options.renderer = this.options.renderer || new _, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new A;
        }
        static parse(e, t) {
            return new a(t).parse(e);
        }
        static parseInline(e, t) {
            return new a(t).parseInline(e);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = "";
            for(let n = 0; n < e.length; n++){
                let i = e[n];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let o = i, s = this.options.extensions.renderers[o.type].call({
                        parser: this
                    }, o);
                    if (s !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "checkbox",
                        "html",
                        "def",
                        "paragraph",
                        "text"
                    ].includes(o.type)) {
                        t += s || "";
                        continue;
                    }
                }
                let r = i;
                switch(r.type){
                    case "space":
                        t += this.renderer.space(r);
                        break;
                    case "hr":
                        t += this.renderer.hr(r);
                        break;
                    case "heading":
                        t += this.renderer.heading(r);
                        break;
                    case "code":
                        t += this.renderer.code(r);
                        break;
                    case "table":
                        t += this.renderer.table(r);
                        break;
                    case "blockquote":
                        t += this.renderer.blockquote(r);
                        break;
                    case "list":
                        t += this.renderer.list(r);
                        break;
                    case "checkbox":
                        t += this.renderer.checkbox(r);
                        break;
                    case "html":
                        t += this.renderer.html(r);
                        break;
                    case "def":
                        t += this.renderer.def(r);
                        break;
                    case "paragraph":
                        t += this.renderer.paragraph(r);
                        break;
                    case "text":
                        t += this.renderer.text(r);
                        break;
                    default:
                        {
                            let o = 'Token with "' + r.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = "";
            for(let i = 0; i < e.length; i++){
                let r = e[i];
                if (this.options.extensions?.renderers?.[r.type]) {
                    let s = this.options.extensions.renderers[r.type].call({
                        parser: this
                    }, r);
                    if (s !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "checkbox",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(r.type)) {
                        n += s || "";
                        continue;
                    }
                }
                let o = r;
                switch(o.type){
                    case "escape":
                        n += t.text(o);
                        break;
                    case "html":
                        n += t.html(o);
                        break;
                    case "link":
                        n += t.link(o);
                        break;
                    case "image":
                        n += t.image(o);
                        break;
                    case "checkbox":
                        n += t.checkbox(o);
                        break;
                    case "strong":
                        n += t.strong(o);
                        break;
                    case "em":
                        n += t.em(o);
                        break;
                    case "codespan":
                        n += t.codespan(o);
                        break;
                    case "br":
                        n += t.br(o);
                        break;
                    case "del":
                        n += t.del(o);
                        break;
                    case "text":
                        n += t.text(o);
                        break;
                    default:
                        {
                            let s = 'Token with "' + o.type + '" type was not found.';
                            if (this.options.silent) return console.error(s), "";
                            throw new Error(s);
                        }
                }
            }
            return n;
        }
    };
    var $ = class {
        options;
        block;
        constructor(e){
            this.options = e || w;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens",
            "emStrongMask"
        ]);
        static passThroughHooksRespectAsync = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer(e = this.block) {
            return e ? T.lex : T.lexInline;
        }
        provideParser(e = this.block) {
            return e ? O.parse : O.parseInline;
        }
    };
    function I(a, e) {
        if (Array.isArray(e)) for(let t = 0; t < e.length; t++)a.push(e[t]);
        else a.push(e);
    }
    var H = class {
        defaults = M();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = O;
        Renderer = _;
        TextRenderer = A;
        Lexer = T;
        Tokenizer = S;
        Hooks = $;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let i of e)switch(I(n, t.call(this, i)), i.type){
                case "table":
                    {
                        let r = i;
                        for (let o of r.header)I(n, this.walkTokens(o.tokens, t));
                        for (let o of r.rows)for (let s of o)I(n, this.walkTokens(s.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let r = i;
                        I(n, this.walkTokens(r.items, t));
                        break;
                    }
                default:
                    {
                        let r = i;
                        this.defaults.extensions?.childTokens?.[r.type] ? this.defaults.extensions.childTokens[r.type].forEach((o)=>{
                            let s = r[o].flat(1 / 0);
                            I(n, this.walkTokens(s, t));
                        }) : r.tokens && I(n, this.walkTokens(r.tokens, t));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((n)=>{
                let i = {
                    ...n
                };
                if (i.async = this.defaults.async || i.async || !1, n.extensions && (n.extensions.forEach((r)=>{
                    if (!r.name) throw new Error("extension name required");
                    if ("renderer" in r) {
                        let o = t.renderers[r.name];
                        o ? t.renderers[r.name] = function(...s) {
                            let l = r.renderer.apply(this, s);
                            return l === !1 && (l = o.apply(this, s)), l;
                        } : t.renderers[r.name] = r.renderer;
                    }
                    if ("tokenizer" in r) {
                        if (!r.level || r.level !== "block" && r.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let o = t[r.level];
                        o ? o.unshift(r.tokenizer) : t[r.level] = [
                            r.tokenizer
                        ], r.start && (r.level === "block" ? t.startBlock ? t.startBlock.push(r.start) : t.startBlock = [
                            r.start
                        ] : r.level === "inline" && (t.startInline ? t.startInline.push(r.start) : t.startInline = [
                            r.start
                        ]));
                    }
                    "childTokens" in r && r.childTokens && (t.childTokens[r.name] = r.childTokens);
                }), i.extensions = t), n.renderer) {
                    let r = this.defaults.renderer || new _(this.defaults);
                    for(let o in n.renderer){
                        if (!(o in r)) throw new Error(`renderer '${o}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(o)) continue;
                        let s = o, l = n.renderer[s], u = r[s];
                        r[s] = (...c)=>{
                            let p = l.apply(r, c);
                            return p === !1 && (p = u.apply(r, c)), p || "";
                        };
                    }
                    i.renderer = r;
                }
                if (n.tokenizer) {
                    let r = this.defaults.tokenizer || new S(this.defaults);
                    for(let o in n.tokenizer){
                        if (!(o in r)) throw new Error(`tokenizer '${o}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(o)) continue;
                        let s = o, l = n.tokenizer[s], u = r[s];
                        r[s] = (...c)=>{
                            let p = l.apply(r, c);
                            return p === !1 && (p = u.apply(r, c)), p;
                        };
                    }
                    i.tokenizer = r;
                }
                if (n.hooks) {
                    let r = this.defaults.hooks || new $;
                    for(let o in n.hooks){
                        if (!(o in r)) throw new Error(`hook '${o}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(o)) continue;
                        let s = o, l = n.hooks[s], u = r[s];
                        $.passThroughHooks.has(o) ? r[s] = (c)=>{
                            if (this.defaults.async && $.passThroughHooksRespectAsync.has(o)) return (async ()=>{
                                let d = await l.call(r, c);
                                return u.call(r, d);
                            })();
                            let p = l.call(r, c);
                            return u.call(r, p);
                        } : r[s] = (...c)=>{
                            if (this.defaults.async) return (async ()=>{
                                let d = await l.apply(r, c);
                                return d === !1 && (d = await u.apply(r, c)), d;
                            })();
                            let p = l.apply(r, c);
                            return p === !1 && (p = u.apply(r, c)), p;
                        };
                    }
                    i.hooks = r;
                }
                if (n.walkTokens) {
                    let r = this.defaults.walkTokens, o = n.walkTokens;
                    i.walkTokens = function(s) {
                        let l = [];
                        return l.push(o.call(this, s)), r && I(l, r.call(this, s)), l;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...i
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return T.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return O.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (n, i)=>{
                let r = {
                    ...i
                }, o = {
                    ...this.defaults,
                    ...r
                }, s = this.onError(!!o.silent, !!o.async);
                if (this.defaults.async === !0 && r.async === !1) return s(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return s(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                if (o.hooks && (o.hooks.options = o, o.hooks.block = e), o.async) return (async ()=>{
                    let l = o.hooks ? await o.hooks.preprocess(n) : n, c = await (o.hooks ? await o.hooks.provideLexer(e) : e ? T.lex : T.lexInline)(l, o), p = o.hooks ? await o.hooks.processAllTokens(c) : c;
                    o.walkTokens && await Promise.all(this.walkTokens(p, o.walkTokens));
                    let f = await (o.hooks ? await o.hooks.provideParser(e) : e ? O.parse : O.parseInline)(p, o);
                    return o.hooks ? await o.hooks.postprocess(f) : f;
                })().catch(s);
                try {
                    o.hooks && (n = o.hooks.preprocess(n));
                    let u = (o.hooks ? o.hooks.provideLexer(e) : e ? T.lex : T.lexInline)(n, o);
                    o.hooks && (u = o.hooks.processAllTokens(u)), o.walkTokens && this.walkTokens(u, o.walkTokens);
                    let p = (o.hooks ? o.hooks.provideParser(e) : e ? O.parse : O.parseInline)(u, o);
                    return o.hooks && (p = o.hooks.postprocess(p)), p;
                } catch (l) {
                    return s(l);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let i = "<p>An error occurred:</p><pre>" + P(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(i) : i;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    var B = new H;
    function g(a, e) {
        return B.parse(a, e);
    }
    g.options = g.setOptions = function(a) {
        return B.setOptions(a), g.defaults = B.defaults, J(g.defaults), g;
    };
    g.getDefaults = M;
    g.defaults = w;
    function Le(...a) {
        return B.use(...a), g.defaults = B.defaults, J(g.defaults), g;
    }
    g.use = Le;
    g.walkTokens = function(a, e) {
        return B.walkTokens(a, e);
    };
    g.parseInline = B.parseInline;
    g.Parser = O;
    g.parser = O.parse;
    g.Renderer = _;
    g.TextRenderer = A;
    g.Lexer = T;
    g.lexer = T.lex;
    g.Tokenizer = S;
    g.Hooks = $;
    g.parse = g;
    var qt = g.options, Zt = g.setOptions, vt = g.walkTokens, Ht = g.parseInline, Gt = g, Nt = O.parse, Qt = T.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});

});

parcelRegister("kr501", function(module, exports) {
/*! @license DOMPurify 3.4.17 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.17/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _OverloadYield(e, d) {
        this.v = e, this.k = d;
    }
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    function AsyncGenerator(e) {
        var t, n;
        function resume(t, n) {
            try {
                var r = e[t](n), o = r.value, u = o instanceof _OverloadYield;
                Promise.resolve(u ? o.v : o).then(function(n) {
                    if (u) {
                        var i = "return" === t && o.k ? t : "next";
                        if (!o.k || n.done) return resume(i, n);
                        n = e[i](n).value;
                    }
                    settle(!!r.done, n);
                }, function(e) {
                    resume("throw", e);
                });
            } catch (e) {
                settle(2, e);
            }
        }
        function settle(e, r) {
            2 === e ? t.reject(r) : t.resolve({
                value: r,
                done: e
            }), (t = t.next) ? resume(t.key, t.arg) : n = null;
        }
        this._invoke = function(e, r) {
            return new Promise(function(o, u) {
                var i = {
                    key: e,
                    arg: r,
                    resolve: o,
                    reject: u,
                    next: null
                };
                n ? n = n.next = i : (t = n = i, resume(e, r));
            });
        }, "function" != typeof e.return && (this.return = void 0);
    }
    AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
        return this;
    }, AsyncGenerator.prototype.next = function(e) {
        return this._invoke("next", e);
    }, AsyncGenerator.prototype.throw = function(e) {
        return this._invoke("throw", e);
    }, AsyncGenerator.prototype.return = function(e) {
        return this._invoke("return", e);
    };
    const entries = Object.entries;
    const setPrototypeOf = Object.setPrototypeOf;
    const isFrozen = Object.isFrozen;
    const getPrototypeOf = Object.getPrototypeOf;
    const getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze;
    let seal = Object.seal;
    let create = Object.create;
    let _ref = typeof Reflect !== "undefined" && Reflect;
    let apply = _ref.apply;
    let construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    Array.prototype.indexOf;
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySlice = unapply(Array.prototype.slice);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const setCreate = unconstruct(Set);
    const setAdd = unapply(Set.prototype.add);
    const setHas = unapply(Set.prototype.has);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === "undefined" ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === "undefined" ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
	* Creates a new function that calls the given function with a specified thisArg and arguments.
	*
	* @param func - The function to be wrapped and called.
	* @returns A new function that calls the given function with a specified thisArg and arguments.
	*/ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
	* Creates a new function that constructs an instance of the given constructor function with the provided arguments.
	*
	* @param func - The constructor function to be wrapped and called.
	* @returns A new function that constructs an instance of the given constructor function with the provided arguments.
	*/ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
	* Add properties to a lookup table
	*
	* @param set - The set to which elements will be added.
	* @param array - The array containing elements to be added to the set.
	* @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
	* @returns The modified set with added elements.
	*/ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
	* Clean up an array to harden against CSPP
	*
	* @param array - The array to be cleaned.
	* @returns The cleaned version of the array
	*/ function cleanArray(array) {
        for(let index = 0; index < array.length; index++)if (!objectHasOwnProperty(array, index)) array[index] = null;
        return array;
    }
    /**
	* Shallow clone an object
	*
	* @param object - The object to be cloned.
	* @returns A new object that copies the original.
	*/ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            if (objectHasOwnProperty(object, property)) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
	* Convert non-node values into strings without depending on direct property access.
	*
	* @param value - The value to stringify.
	* @returns A string representation of the provided value.
	*/ function stringifyValue(value) {
        switch(typeof value){
            case "string":
                return value;
            case "number":
                return numberToString(value);
            case "boolean":
                return booleanToString(value);
            case "bigint":
                return bigintToString ? bigintToString(value) : "0";
            case "symbol":
                return symbolToString ? symbolToString(value) : "Symbol()";
            case "undefined":
                return objectToString(value);
            case "function":
            case "object":
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, "toString");
                    if (typeof valueToString === "function") {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === "string" ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
	* This method automatically checks if the prop is function or getter and behaves accordingly.
	*
	* @param object - The object to look up the getter function in its prototype chain.
	* @param prop - The property name for which to find the getter function.
	* @returns The getter function found in the prototype chain or a fallback function.
	*/ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    /**
	* Like lookupGetter, but for accessor properties only, and returns null
	* instead of a null-returning fallback when no getter exists on the chain.
	* Lets a caller fall back to a direct property read in environments that
	* lack the getter, where a fallback returning null would be indistinguishable
	* from a legitimate null value (e.g. namespaceURI of a no-namespace element).
	*
	* @param object - The object (usually a prototype) to start the lookup at.
	* @param prop - The accessor property name.
	* @returns The unapplied getter, or null if none was found.
	*/ function lookupAccessor(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) return desc.get ? unapply(desc.get) : null;
            object = getPrototypeOf(object);
        }
        return null;
    }
    function isRegex(value) {
        try {
            regExpTest(value, "");
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "search",
        "section",
        "select",
        "shadow",
        "slot",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "enterkeyhint",
        "exportparts",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "inputmode",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "part",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "command",
        "commandfor",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "exportparts",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inert",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "part",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "mask-type",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "pointer-events",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-orientation",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "vector-effect",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnalign",
        "columnlines",
        "columnspacing",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lquote",
        "lspace",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/);
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    const ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
    const COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
    const FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
    const SELF_CLOSING_TAG = seal(/\/>/i);
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        entityNode: 6,
        processingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12
    };
    const LITERAL_TEXT_ELEMENTS = freeze(addToSet({}, [
        "style",
        "script",
        "xmp",
        "iframe",
        "noembed",
        "noframes",
        "plaintext",
        "noscript"
    ]));
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
	* Creates a no-op policy for internal use only.
	* Don't export this function outside this module!
	* @param trustedTypes The policy factory.
	* @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
	* @return The policy created (or null, if Trusted Types
	* are not supported or creating the policy failed).
	*/ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    /**
	* Resolve a set-valued configuration option: a fresh set built from
	* cfg[key] when it is an own array property (seeded with a clone of
	* options.base when given, case-normalized via options.transform),
	* the fallback set otherwise.
	*
	* @param cfg the cloned, prototype-free configuration object
	* @param key the configuration property to read
	* @param fallback the set to use when the option is absent or not an array
	* @param options transform and optional base set to merge into
	* @returns the resolved set
	*/ const _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
        return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
    };
    /**
	* Resolve an object-valued configuration option: a prototype-free clone
	* of cfg[key] when it is an own, truthy object property, else a fresh
	* fallback built by makeFallback (fresh on every parse, so a previous
	* parse can never leak state into the next one).
	*
	* @param cfg the cloned, prototype-free configuration object
	* @param key the configuration property to read
	* @param makeFallback builds the fallback value when the option is absent
	* @returns the resolved object
	*/ const _resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
        const value = objectHasOwnProperty(cfg, key) ? cfg[key] : void 0;
        return value && typeof value === "object" ? clone(value) : makeFallback();
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = "3.4.17";
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter;
        window1.NamedNodeMap === void 0 && (window1.NamedNodeMap || window1.MozNamedAttrMap);
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const remove = lookupGetter(ElementPrototype, "remove");
        const removeAttributeNode = lookupGetter(ElementPrototype, "removeAttributeNode");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        const getShadowRoot = lookupGetter(ElementPrototype, "shadowRoot");
        const getAttributes = lookupGetter(ElementPrototype, "attributes");
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeType") : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeName") : null;
        const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, "ownerDocument") : null;
        const _readNodeType = function _readNodeType(node) {
            return getNodeType ? getNodeType(node) : node.nodeType;
        };
        const _readNodeName = function _readNodeName(node) {
            return getNodeName ? getNodeName(node) : node.nodeName;
        };
        const getNamespaceURI = lookupAccessor(ElementPrototype, "namespaceURI");
        const _readNamespaceURI = function _readNamespaceURI(element) {
            return getNamespaceURI ? getNamespaceURI(element) : element.namespaceURI;
        };
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        let defaultTrustedTypesPolicy;
        let defaultTrustedTypesPolicyResolved = false;
        let IN_TRUSTED_TYPES_POLICY = 0;
        const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
            if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
        };
        const _createTrustedHTML = function _createTrustedHTML(html) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createHTML(html);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createScriptURL(scriptUrl);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
            if (!defaultTrustedTypesPolicyResolved) {
                defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                defaultTrustedTypesPolicyResolved = true;
            }
            return defaultTrustedTypesPolicy;
        };
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
		* Expose whether this browser supports running the full DOMPurify.
		*/ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
		* We consider the elements and attributes below to be safe. Ideally
		* don't add any new ones but feel free to remove unwanted ones.
		*/ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        let FORBID_TAGS = null;
        let FORBID_ATTR = null;
        const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        let ALLOW_ARIA_ATTR = true;
        let ALLOW_DATA_ATTR = true;
        let ALLOW_UNKNOWN_PROTOCOLS = false;
        let ALLOW_SELF_CLOSE_IN_ATTR = true;
        let SAFE_FOR_TEMPLATES = false;
        let SAFE_FOR_XML = true;
        let WHOLE_DOCUMENT = false;
        let SET_CONFIG = false;
        let SET_CONFIG_ALLOWED_TAGS = null;
        let SET_CONFIG_ALLOWED_ATTR = null;
        let FORCE_BODY = false;
        let RETURN_DOM = false;
        let RETURN_DOM_FRAGMENT = false;
        let RETURN_TRUSTED_TYPE = false;
        let SANITIZE_DOM = true;
        let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        let KEEP_CONTENT = true;
        let IN_PLACE = false;
        let IN_PLACE_VISITED = null;
        let USE_PROFILES = {};
        let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "selectedcontent",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze([
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
        const DEFAULT_HTML_INTEGRATION_POINTS = freeze([
            "annotation-xml"
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        let CONFIG = null;
        const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
		* _parseConfig
		*
		* @param cfg optional config literal
		*/ const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            if (!cfg || typeof cfg !== "object") cfg = {};
            cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            ALLOWED_TAGS = _resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, {
                transform: transformCaseFunc
            });
            ALLOWED_ATTR = _resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, {
                transform: transformCaseFunc
            });
            ALLOWED_NAMESPACES = _resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, {
                transform: stringToString
            });
            URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
                transform: transformCaseFunc,
                base: DEFAULT_URI_SAFE_ATTRIBUTES
            });
            DATA_URI_TAGS = _resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
                transform: transformCaseFunc,
                base: DEFAULT_DATA_URI_TAGS
            });
            FORBID_CONTENTS = _resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, {
                transform: transformCaseFunc
            });
            FORBID_TAGS = _resolveSetOption(cfg, "FORBID_TAGS", clone({}), {
                transform: transformCaseFunc
            });
            FORBID_ATTR = _resolveSetOption(cfg, "FORBID_ATTR", clone({}), {
                transform: transformCaseFunc
            });
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
            RETURN_DOM = cfg.RETURN_DOM || false;
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
            FORCE_BODY = cfg.FORCE_BODY || false;
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
            IN_PLACE = cfg.IN_PLACE || false;
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI;
            NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, "MATHML_TEXT_INTEGRATION_POINTS", ()=>addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS));
            HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, "HTML_INTEGRATION_POINTS", ()=>addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS));
            const customElementHandling = _resolveObjectOption(cfg, "CUSTOM_ELEMENT_HANDLING", ()=>create(null));
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
            if (objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
            if (objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
            seal(CUSTOM_ELEMENT_HANDLING);
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            if (objectHasOwnProperty(cfg, "ADD_TAGS")) {
                if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, "ADD_ATTR")) {
                if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
                const previousTrustedTypesPolicy = trustedTypesPolicy;
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                try {
                    emptyHTML = _createTrustedHTML("");
                } catch (error) {
                    trustedTypesPolicy = previousTrustedTypesPolicy;
                    throw error;
                }
            } else if (cfg.TRUSTED_TYPES_POLICY === null) {
                trustedTypesPolicy = void 0;
                emptyHTML = "";
            } else {
                if (trustedTypesPolicy === void 0) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
                if (trustedTypesPolicy && typeof emptyHTML === "string") emptyHTML = _createTrustedHTML("");
            }
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
		* Namespace rules for an element in the SVG namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            return Boolean(ALL_SVG_TAGS[tagName]);
        };
        /**
		* Namespace rules for an element in the MathML namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
            return Boolean(ALL_MATHML_TAGS[tagName]);
        };
        /**
		* Namespace rules for an element in the HTML namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        };
        /**
		* @param element a DOM element whose namespace is being checked
		* @returns Return false if the element has a
		*  namespace that a spec-compliant parser would never
		*  return. Return true otherwise.
		*/ const _checkValidNamespace = function _checkValidNamespace(element) {
            const elementNamespace = _readNamespaceURI(element);
            const tagName = stringToLowerCase(_readNodeName(element));
            const parentNode = getParentNode(element);
            let parent;
            let parentTagName;
            if (parentNode && _readNodeType(parentNode) === NODE_TYPE.element) {
                parent = {
                    namespaceURI: _readNamespaceURI(parentNode)
                };
                parentTagName = stringToLowerCase(_readNodeName(parentNode));
            } else {
                parent = {
                    namespaceURI: NAMESPACE
                };
                parentTagName = "template";
            }
            if (!ALLOWED_NAMESPACES[elementNamespace]) return false;
            if (elementNamespace === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
            if (elementNamespace === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
            if (elementNamespace === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[elementNamespace]) return true;
            return false;
        };
        /**
		* _forceRemove
		*
		* @param node a DOM node
		*/ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
                if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
            }
        };
        /**
		* _stripAttributeNode
		*
		* Remove a single Attr node case/namespace-exactly on an attribute-teardown
		* path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
		* HTML element in an HTML document and so silently misses a case-preserved
		* handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
		* _removeAttribute() was fixed for, which a name-based call would reintroduce
		* on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
		* record into DOMPurify.removed: the neutralize passes intentionally do not
		* book-keep. A clobbered/detached node falls back to best-effort name-based
		* removal.
		*
		* @param element the element to strip the attribute from
		* @param attribute the Attr node to remove
		* @param name the attribute's name, for the fallback path
		*/ const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
            try {
                removeAttributeNode(element, attribute);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
        };
        /**
		* Fail-closed teardown of an in-place root: strip every disallowed attribute
		* in the subtree first, so nothing armed is left behind, then remove all
		* children and the root's own attributes.
		*
		* @param root the in-place root to empty
		*/ const _neutralizeRoot = function _neutralizeRoot(root) {
            _neutralizeSubtree(root);
            const childNodes = getChildNodes(root);
            if (childNodes) arrayForEach(arraySlice(childNodes), (child)=>{
                try {
                    remove(child);
                } catch (_) {}
            });
            const attributes = _readNodeType(root) === NODE_TYPE.element ? getAttributes(root) : null;
            if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name === "string") _stripAttributeNode(root, attribute, name);
            }
        };
        /**
		* Removes an attribute, preferably as its exact Attr node: name-based
		* removal lowercases the name in HTML documents and misses case-preserved
		* names, e.g. from imported XHTML.
		*
		* @param name an Attribute name
		* @param element a DOM node
		* @param attr the exact Attr node to remove, when the caller has it
		*/ const _removeAttribute = function _removeAttribute(name, element, attr) {
            if (!attr) try {
                attr = element.getAttributeNode(name);
            } catch (_) {
                attr = null;
            }
            arrayPush(DOMPurify.removed, {
                attribute: attr || null,
                from: element
            });
            try {
                if (attr) removeAttributeNode(element, attr);
                else element.removeAttribute(name);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
            if (name === "is") {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
		* Removes every attribute the configuration does not allow. Used to
		* neutralize nodes discarded from an in-place tree.
		*
		* @param element the element to strip
		*/ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
            const attributes = getAttributes(element);
            if (!attributes) return;
            for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
                _stripAttributeNode(element, attribute, name);
            }
        };
        /**
		* Iterative depth-first walk, so deep trees cannot overflow the call stack,
		* reading through the cached getters, so clobbering cannot hide children.
		* When `visit` returns false, the node's children are skipped. With
		* `intoShadow`, open shadow roots are walked after their host's children.
		*
		* @param root where to start
		* @param visit called for every node
		* @param intoShadow whether to enter open shadow roots
		*/ const _walkTree = function _walkTree(root, visit) {
            let intoShadow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                if (visit(node) === false) continue;
                if (intoShadow && _readNodeType(node) === NODE_TYPE.element) {
                    const shadowRoot = getShadowRoot(node);
                    if (_isDocumentFragment(shadowRoot)) stack.push(shadowRoot);
                }
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
		* Strips disallowed attributes from every element of a discarded subtree,
		* so a handler that is already queued (a loading image) cannot fire.
		*
		* @param root the root of a removed subtree
		*/ const _neutralizeSubtree = function _neutralizeSubtree(root) {
            _walkTree(root, (node)=>{
                if (_readNodeType(node) === NODE_TYPE.element) _stripDisallowedAttributes(node);
            });
        };
        /**
		* All nodes under `root`, root first, including open shadow roots. Template
		* content is not entered, it is inert.
		*
		* @param root the in-place root
		* @return the nodes
		*/ const _collectLiveNodes = function _collectLiveNodes(root) {
            const nodes = [];
            _walkTree(root, (node)=>{
                nodes.push(node);
            }, true);
            return nodes;
        };
        /**
		* Strips disallowed attributes from every element that was under the
		* in-place root when the call started and no longer is, whatever removed
		* or moved it.
		*
		* @param root the in-place root
		* @param before the root's nodes, collected before the walk
		*/ const _neutralizeEscapedElements = function _neutralizeEscapedElements(root, before) {
            const reachable = setCreate();
            arrayForEach(_collectLiveNodes(root), (node)=>{
                if (_readNodeType(node) === NODE_TYPE.element) setAdd(reachable, node);
            });
            arrayForEach(before, (node)=>{
                if (_readNodeType(node) === NODE_TYPE.element && !setHas(reachable, node)) _stripDisallowedAttributes(node);
            });
        };
        /**
		* Neutralizes everything that left the in-place tree during the call: what
		* DOMPurify removed, and what hooks or custom elements removed or moved out.
		*
		* @param root the in-place root
		* @param before the root's nodes, collected before the walk
		* @return true if the root itself was removed
		*/ const _neutralizeDiscarded = function _neutralizeDiscarded(root, before) {
            let rootRemoved = false;
            arrayForEach(DOMPurify.removed, (entry)=>{
                if (entry.element) {
                    rootRemoved = rootRemoved || entry.element === root;
                    _neutralizeSubtree(entry.element);
                }
            });
            _neutralizeEscapedElements(root, before);
            return rootRemoved;
        };
        const MAX_UNVISITED_ROUNDS = 8;
        /**
		* The walk only moves forward, so a node moved to a position it already
		* passed is never visited. Give every original node that is still in the
		* tree but unvisited the normal treatment, hooks included. Nodes created
		* during the call are left alone. Fails closed if the tree keeps changing.
		*
		* @param root the in-place root
		* @param before the root's nodes, collected before the walk
		*/ const _sanitizeUnvisitedNodes = function _sanitizeUnvisitedNodes(root, before) {
            const visited = IN_PLACE_VISITED;
            let original = null;
            const getOriginal = ()=>{
                if (!original) {
                    original = setCreate();
                    arrayForEach(before, (beforeNode)=>{
                        setAdd(original, beforeNode);
                    });
                }
                return original;
            };
            for(let round = 0;; round++){
                const live = _collectLiveNodes(root);
                const containers = [
                    root
                ];
                let pending = false;
                arrayForEach(live, (node)=>{
                    if (_readNodeType(node) === NODE_TYPE.documentFragment) arrayPush(containers, node);
                    else if (!pending && !setHas(visited, node)) pending = setHas(getOriginal(), node);
                });
                if (!pending) return;
                if (round >= MAX_UNVISITED_ROUNDS) throw typeErrorCreate("the tree kept changing during in-place sanitization; refusing to return it");
                arrayForEach(containers, (container, index)=>{
                    _sanitizeUnvisitedIn(container, index > 0, root, getOriginal());
                });
            }
        };
        /**
		* One _sanitizeUnvisitedNodes pass over the root or an open shadow root.
		*
		* @param container the root or an open shadow root
		* @param inShadow whether container is a shadow root
		* @param root the in-place root
		* @param original the root's nodes collected before the walk, as a set
		*/ const _sanitizeUnvisitedIn = function _sanitizeUnvisitedIn(container, inShadow, root, original) {
            const iterator = _createNodeIterator(container);
            let node;
            while(node = iterator.nextNode()){
                if (!setHas(original, node) || setHas(IN_PLACE_VISITED, node)) continue;
                if (inShadow) _executeHooks(hooks.uponSanitizeShadowNode, node, null);
                _sanitizeElements(node, root);
                _sanitizeAttributes(node, root);
                if (_isDocumentFragment(node.content)) _sanitizeShadowDOM2(node.content);
            }
        };
        /**
		* Records that _sanitizeElements processed `node`. No-op outside IN_PLACE.
		*
		* @param node the node being processed
		*/ const _markVisited = function _markVisited(node) {
            if (IN_PLACE_VISITED) setAdd(IN_PLACE_VISITED, node);
        };
        /**
		* Patch-linkage attributes (declarative partial updates): `patchsrc`
		* always, `for` everywhere except on <label> and <output>. Gated on
		* SAFE_FOR_XML. Shared by the IN_PLACE pre-pass and _isValidAttribute.
		*
		* @param lcName the transformCaseFunc'd attribute name
		* @param lcTag the transformCaseFunc'd tag name of the carrying element
		* @return true if the attribute is patch linkage and must be dropped
		*/ const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
            if (!SAFE_FOR_XML) return false;
            if (lcName === "patchsrc") return true;
            return lcName === "for" && lcTag !== "label" && lcTag !== "output";
        };
        /**
		* IN_PLACE pre-pass: sever all patch linkage before the walk, so no patch
		* can fire mid-walk into a part of the tree the walker already passed.
		* Removes range markers (processing instructions, comments with markup)
		* and strips linkage attributes. It cannot undo a patch that already fired.
		*
		* TODO: if the shipped feature can patch through `for` on <label>/<output>,
		* drop that pair here too (see test/declarative-patch-probe.html).
		*
		* @param root the in-place root to sweep
		*/ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
            if (!SAFE_FOR_XML) return;
            _walkTree(root, (node)=>{
                const nodeType = _readNodeType(node);
                if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
                    try {
                        remove(node);
                    } catch (_) {}
                    return false;
                }
                if (nodeType === NODE_TYPE.element) {
                    const element = node;
                    const lcTag = transformCaseFunc(_readNodeName(node));
                    try {
                        if (element.hasAttribute && element.hasAttribute("patchsrc")) element.removeAttribute("patchsrc");
                        if (element.hasAttribute && element.hasAttribute("for") && _isPatchLinkageAttribute("for", lcTag)) element.removeAttribute("for");
                    } catch (_) {}
                }
                return true;
            });
        };
        /**
		* _initDocument
		*
		* @param dirty - a string of dirty markup
		* @return a DOM, filled with the dirty markup
		*/ const _initDocument = function _initDocument(dirty) {
            let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) dirty = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
            if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {}
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
		* Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
		*
		* @param root The root element or node to start traversing on.
		* @return The created NodeIterator
		*/ const _createNodeIterator = function _createNodeIterator(root) {
            const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
            return createNodeIterator.call(doc || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
		* Replace template expression syntax (mustache, ERB, template
		* literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
		* sites. Order matters: mustache, then ERB, then template literal.
		*
		* @param value the string to scrub
		* @returns the scrubbed string
		*/ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
            value = stringReplace(value, MUSTACHE_EXPR$1, " ");
            value = stringReplace(value, ERB_EXPR$1, " ");
            value = stringReplace(value, TMPLIT_EXPR$1, " ");
            return value;
        };
        /**
		* Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
		* character data of an element subtree. Used as the final safety net for
		* SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
		* which only form after text-node normalization (e.g. fragments split across
		* stripped elements) cannot survive into a template-evaluating framework.
		*
		* Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
		* in place rather than round-tripping through innerHTML. This preserves
		* descendant node references (important for IN_PLACE callers), avoids a
		* serialize/reparse cycle, and reads literal character data — which means
		* `<%...%>` in text content matches the ERB regex against its real bytes
		* instead of the HTML-entity-escaped form innerHTML would produce.
		*
		* Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
		* attributes is performed during the per-node `_sanitizeAttributes` pass.
		*
		* @param node The root element whose character data should be scrubbed.
		*/ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
            var _node$querySelectorAl;
            _scrubOwnCharacterData(node);
            const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
            if (templates) arrayForEach(templates, (tmpl)=>{
                if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
            });
        };
        /**
		* _scrubOwnCharacterData
		*
		* Non-recursive core of _scrubTemplateExpressions: normalize `node` and
		* strip template expressions from its own character data only. Does not
		* enter <template>.content or attached shadow roots (NodeIterator never
		* does). Used by _sanitizeShadowDOM, where every nested template content
		* and shadow root is already walked - and therefore scrubbed - by its own
		* recursive _sanitizeShadowDOM call; recursing here as well would rescrub
		* each nested fragment once per ancestor, which is quadratic in nesting
		* depth.
		*
		* @param node The root whose own character data should be scrubbed.
		*/ const _scrubOwnCharacterData = function _scrubOwnCharacterData(node) {
            node.normalize();
            const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
            const walker = createNodeIterator.call(doc || node, node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                currentNode.data = _stripTemplateExpressions(currentNode.data);
                currentNode = walker.nextNode();
            }
        };
        /**
		* _isClobbered
		*
		* Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
		* interface with [LegacyOverrideBuiltIns]; a descendant element with a
		* `name` attribute matching a prototype property shadows that property
		* on direct reads. We use this check at the IN_PLACE entry-point and
		* during attribute sanitization to refuse clobbered forms.
		*
		* @param element element to check for clobbering attacks
		* @return true if clobbered, false if safe
		*/ const _isClobbered = function _isClobbered(element) {
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== "string") return false;
            if (transformCaseFunc(realTagName) !== "form") return false;
            return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.removeAttributeNode !== "function" || typeof element.getAttributeNode !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || element.nodeType !== getNodeType(element) || element.childNodes !== getChildNodes(element);
        };
        /**
		* Checks whether the given value is a DocumentFragment from any realm.
		*
		* The realm-independent replacement reads `nodeType` through the cached
		* Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
		* constant (11). nodeType is a numeric value resolved from the node's
		* internal slot, identical across realms for the same kind of node.
		*
		* @param value object to check
		* @return true if value is a DocumentFragment-shaped node from any realm
		*/ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== "object" || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
		* Checks whether the given object is a DOM node, including nodes that
		* originate from a different window/realm (e.g. an iframe's
		* contentDocument). The previous `value instanceof Node` check was
		* realm-bound: nodes from a different window failed it, causing
		* sanitize() to silently stringify them and reset IN_PLACE to false,
		* returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
		*
		* @param value object to check whether it's a DOM node
		* @return true if value is a DOM node from any realm
		*/ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== "object" || value === null) return false;
            try {
                return typeof getNodeType(value) === "number";
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            if (hooks.length === 0) return;
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
		* Structural-threat checks that condemn a node regardless of the
		* allowlists: mXSS via namespace confusion, risky CSS construction,
		* processing instructions, markup-bearing comments. Pure predicate;
		* the caller removes. Check order is load-bearing.
		*
		* @param currentNode the node to inspect
		* @param tagName the node's transformCaseFunc'd tag name
		* @return true if the node must be removed
		*/ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
            if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
            if (SAFE_FOR_XML && LITERAL_TEXT_ELEMENTS[tagName] && _readNodeType(currentNode) === NODE_TYPE.element && _readNamespaceURI(currentNode) === HTML_NAMESPACE && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === "string" && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent))) return true;
            if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
            if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
            return false;
        };
        /**
		* Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
		* function, per the validation in _parseConfig) against a name.
		* Additional arguments are forwarded to predicate functions - the
		* attributeNameCheck predicate receives the tag name as its second
		* argument. A null/absent check never matches.
		*
		* @param check the configured tagNameCheck / attributeNameCheck value
		* @param name the name to test
		* @param args extra arguments forwarded to a predicate function
		* @return true if the check matches the name
		*/ const _matchesNameCheck = function _matchesNameCheck(check, name) {
            if (check instanceof RegExp) return regExpTest(check, name);
            if (check instanceof Function) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                return Boolean(check(name, ...args));
            }
            return false;
        };
        /**
		* Handle a node whose tag is forbidden or not allowlisted: keep
		* allowed custom elements (false return exits _sanitizeElements
		* early - the namespace and fallback-tag removal checks are
		* intentionally skipped for kept custom elements), else hoist
		* content per KEEP_CONTENT and remove.
		*
		* A kept custom element is the ONLY case in which this function
		* returns false, so the caller uses that return value to run the
		* afterSanitizeElements hook on the kept element and keep the
		* element-hook lifecycle consistent with normal allowlisted
		* elements (GHSA-c2j3-45gr-mqc4).
		*
		* @param currentNode the disallowed node
		* @param tagName the node's transformCaseFunc'd tag name
		* @return true if the node was removed, false if kept
		*/ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
            if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && !FORBID_CONTENTS[stringToLowerCase(tagName)]) {
                const parentNode = getParentNode(currentNode);
                const childNodes = getChildNodes(currentNode);
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                        parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        };
        /**
		* Fork a hook-mutable allowlist off its shared binding the first time a
		* (possibly lazily-installed) uponSanitize* hook is about to see it, so the
		* hook cannot widen the per-instance default or the setConfig binding by
		* reference and leak past the call. Returns the set unchanged once it is
		* already call-local, so repeated calls across elements are idempotent.
		*
		* @param hookList the uponSanitize* hook array for this event
		* @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
		* @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
		* @param setConfigSet the captured setConfig() binding, or null
		* @return a call-local clone if a hook is present and set is still shared,
		*   else set unchanged
		*/ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
            if (hookList.length === 0) return set;
            return set === defaultSet || set === setConfigSet ? clone(set) : set;
        };
        /**
		* A hook may have detached the node it was called for. If so, treat it as
		* removed and stop processing it; the walk root is exempt. On the IN_PLACE
		* path the detached subtree is neutralized right away.
		*
		* @param currentNode the node a hook may have detached
		* @param root the current walk root
		* @return true if the node was detached
		*/ const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
            if (currentNode === root || getParentNode(currentNode) !== null) return false;
            if (IN_PLACE) _neutralizeSubtree(currentNode);
            return true;
        };
        /**
		* _sanitizeElements
		*
		* @protect nodeName
		* @protect textContent
		* @protect removeChild
		* @param currentNode to check for permission to exist
		* @return true if node was killed, false if left alive
		*/ const _sanitizeElements = function _sanitizeElements(currentNode, root) {
            _markVisited(currentNode);
            _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            if (_handleHookDetachedNode(currentNode, root)) return true;
            if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            const tagName = transformCaseFunc(_readNodeName(currentNode));
            ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
            _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            if (_handleHookDetachedNode(currentNode, root)) return true;
            if (_isUnsafeNode(currentNode, tagName)) {
                _forceRemove(currentNode);
                return true;
            }
            if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
                if (removed === false) {
                    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                    if (_handleHookDetachedNode(currentNode, root)) return true;
                }
                return removed;
            }
            if (_readNodeType(currentNode) === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                const content = _stripTemplateExpressions(currentNode.textContent);
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return _handleHookDetachedNode(currentNode, root);
        };
        /**
		* _isValidAttribute
		*
		* @param lcTag Lowercase tag name of containing element.
		* @param lcName Lowercase attribute name.
		* @param value Attribute value.
		* @return Returns true if `value` is valid, otherwise false.
		*/ const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            if (FORBID_ATTR[lcName]) return false;
            if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
            if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) return true;
            if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) return true;
            if (!nameIsPermitted) return _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value);
            if (URI_SAFE_ATTRIBUTES[lcName]) return true;
            if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
            if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) return true;
            if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
            return !value;
        };
        const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            "annotation-xml",
            "color-profile",
            "font-face",
            "font-face-format",
            "font-face-name",
            "font-face-src",
            "font-face-uri",
            "missing-glyph"
        ]);
        /**
		* _isBasicCustomElement
		* checks if at least one dash is included in tagName, and it's not the first char
		* for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
		*
		* @param tagName name of the tag of the node to sanitize
		* @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
		*/ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
		* Wrap an attribute value in the matching Trusted Types object when
		* the active policy requires it. Namespaced attributes pass through
		* unchanged (no TT support yet, see
		* https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
		*
		* @param lcTag lowercase tag name of the containing element
		* @param lcName lowercase attribute name
		* @param namespaceURI the attribute's namespace, if any
		* @param value the attribute value to wrap
		* @return the value, wrapped when Trusted Types demand it
		*/ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
            if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
                case "TrustedHTML":
                    return _createTrustedHTML(value);
                case "TrustedScriptURL":
                    return _createTrustedScriptURL(value);
            }
            return value;
        };
        /**
		* Write a modified attribute value back onto the element. On
		* success, re-probe for clobbering introduced by the new value and
		* remove the element when found; otherwise, when this writeback is the
		* recreate half of the SANITIZE_NAMED_PROPS remove-and-recreate, pop the
		* removal entry that path recorded so it does not show as removed. On
		* failure, remove the attribute instead.
		*
		* Returns true only on a clean write (the value was set and the new value
		* introduced no clobbering). The caller uses that, together with its own
		* knowledge of whether this attribute pushed a DOMPurify.removed record, to
		* decide whether to pop that record. The pop must happen ONLY for the
		* named-prop remove-and-recreate; popping on any other value change (trim,
		* template scrubbing, Trusted Types) would consume an unrelated _forceRemove
		* subtree-cleanup record and let that detached subtree keep a live event
		* handler through the IN_PLACE neutralization pass (SO-001).
		*
		* @param currentNode the element carrying the attribute
		* @param name the attribute name as present on the element
		* @param namespaceURI the attribute's namespace, if any
		* @param value the new attribute value
		* @return true if the value was written without introducing clobbering
		*/ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
            try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) {
                    _forceRemove(currentNode);
                    return false;
                }
                return true;
            } catch (_) {
                _removeAttribute(name, currentNode);
                return false;
            }
        };
        /**
		* _isUnsafeAttributeValue
		*
		* Value-based attribute checks that the attribute walk applies before any
		* hook can force-keep an attribute, shared with the public
		* isValidAttribute() so that it never approves a value sanitize() would
		* strip.
		*
		* @param name the attribute name as found on the node (case preserved)
		* @param value the attribute value
		* @returns true if the attribute must be removed because of its value
		*/ const _isUnsafeAttributeValue = function _isUnsafeAttributeValue(name, value) {
            if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) return true;
            return stringToLowerCase(name) === "attributename" && stringMatch(value, "href") !== null;
        };
        /**
		* _sanitizeAttributes
		*
		* @protect attributes
		* @protect nodeName
		* @protect removeAttribute
		* @protect setAttribute
		*
		* @param currentNode to sanitize
		* @param root the current walk root
		*/ const _sanitizeAttributes = function _sanitizeAttributes(currentNode, root) {
            _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            if (_handleHookDetachedNode(currentNode, root)) return;
            const attributes = currentNode.attributes;
            if (!attributes || _isClobbered(currentNode)) return;
            ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: void 0
            };
            let l = attributes.length;
            const lcTag = transformCaseFunc(currentNode.nodeName);
            while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === "value" ? initValue : stringTrim(initValue);
                let recreatedNamedProp = false;
                hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = void 0;
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    _removeAttribute(name, currentNode, attr);
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                    recreatedNamedProp = true;
                }
                if (_isUnsafeAttributeValue(name, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (hookEvent.forceKeepAttr) continue;
                if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
                if (value !== initValue) {
                    if (_setAttributeValue(currentNode, name, namespaceURI, value) && recreatedNamedProp) arrayPop(DOMPurify.removed);
                }
            }
            _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
            _handleHookDetachedNode(currentNode, root);
        };
        /**
		* _sanitizeShadowDOM
		*
		* @param fragment to iterate over recursively
		*/ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                _sanitizeElements(shadowNode, fragment);
                _sanitizeAttributes(shadowNode, fragment);
                if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                if (_readNodeType(shadowNode) === NODE_TYPE.element) {
                    const innerSr = getShadowRoot(shadowNode);
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            if (SAFE_FOR_TEMPLATES) _scrubOwnCharacterData(fragment);
            _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
		* Sanitizes every attached shadow root under `root`, since the node
		* iterator does not enter shadow trees. Needed for IN_PLACE input and for
		* DOM input whose clonable shadow roots were copied by importNode().
		*
		* @param root the subtree root to walk for attached shadow roots
		*/ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
            const stack = [
                {
                    node: root,
                    shadow: null
                }
            ];
            while(stack.length > 0){
                const item = stack.pop();
                if (item.shadow) {
                    _sanitizeShadowDOM2(item.shadow);
                    continue;
                }
                const node = item.node;
                const isElement = _readNodeType(node) === NODE_TYPE.element;
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                    node: childNodes[i],
                    shadow: null
                });
                if (isElement) {
                    const rootName = getNodeName ? getNodeName(node) : null;
                    if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
                        const content = node.content;
                        if (_isDocumentFragment(content)) stack.push({
                            node: content,
                            shadow: null
                        });
                    }
                }
                if (isElement) {
                    const sr = getShadowRoot(node);
                    if (_isDocumentFragment(sr)) stack.push({
                        node: null,
                        shadow: sr
                    }, {
                        node: sr,
                        shadow: null
                    });
                }
            }
        };
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            if (typeof dirty !== "string" && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
            }
            if (!DOMPurify.isSupported) return dirty;
            if (SET_CONFIG) {
                ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
                ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
            } else _parseConfig(cfg);
            if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            DOMPurify.removed = [];
            const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
            let inPlaceNodes = [];
            const outerVisited = IN_PLACE_VISITED;
            if (inPlace) {
                _neutralizePatchLinkage(dirty);
                const nn = _readNodeName(dirty);
                if (typeof nn === "string") {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                        _neutralizeRoot(dirty);
                        throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                    }
                }
                if (_isClobbered(dirty)) {
                    _neutralizeRoot(dirty);
                    throw typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
                }
                inPlaceNodes = _collectLiveNodes(dirty);
                IN_PLACE_VISITED = setCreate();
            } else if (_isNode(dirty)) {
                body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else body.appendChild(importedNode);
                _sanitizeAttachedShadowRoots(body);
            } else {
                if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
                body = _initDocument(dirty);
                if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            if (body && FORCE_BODY) _forceRemove(body.firstChild);
            const walkRoot = inPlace ? dirty : body;
            try {
                if (inPlace) _sanitizeAttachedShadowRoots(dirty);
                const nodeIterator = _createNodeIterator(walkRoot);
                while(currentNode = nodeIterator.nextNode()){
                    _sanitizeElements(currentNode, walkRoot);
                    _sanitizeAttributes(currentNode, walkRoot);
                    if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
                }
                if (inPlace) _sanitizeUnvisitedNodes(dirty, inPlaceNodes);
            } catch (error) {
                if (inPlace) {
                    _neutralizeRoot(dirty);
                    _neutralizeDiscarded(dirty, inPlaceNodes);
                }
                throw error;
            } finally{
                IN_PLACE_VISITED = outerVisited;
            }
            if (inPlace) {
                if (_neutralizeDiscarded(dirty, inPlaceNodes)) throw typeErrorCreate("a node selected for removal could not be safely returned; refusing to sanitize in place");
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
                return dirty;
            }
            if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
            SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
            SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
            SET_CONFIG_ALLOWED_TAGS = null;
            SET_CONFIG_ALLOWED_ATTR = null;
            trustedTypesPolicy = defaultTrustedTypesPolicy;
            emptyHTML = "";
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            if (typeof value === "string" && (_isUnsafeAttributeValue(attr, value) || !ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value))) return false;
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            if (hookFunction !== void 0) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? void 0 : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    return createDOMPurify();
});

});


//# sourceMappingURL=prsm.c8ddbea5.js.map
